import React from "react";

import * as Constants from "../../../../../consts/Constants.js";

import IconButton from '@mui/material/IconButton';
import CircularProgress from '@mui/material/CircularProgress';
import RefreshIcon from '@mui/icons-material/Refresh';
import LaunchIcon from '@mui/icons-material/Launch';
import Style from "../../../../../styles/js/StyleCallList.js";

import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import { Grid } from "@material-ui/core";
import NewWindow from 'react-new-window'

import ConfigurationPreview from "./configuration-preview";
import service from "../../../../../plas/services/calls/service.jsx";

export default function ConfigurationSelector( { select, preSelect, disabled} ) {

    const [preview, setPreview] = React.useState(false);
  	const [loading, setLoading] = React.useState(false);
  	const [configurations, setConfigurations] = React.useState(null);
  	const [selectedConfig, setSelectedConfig] = React.useState(null);

    const style = Style();

  	React.useEffect(() => {
    	getConfigurations();
  	}, []);

    React.useEffect(() => {
      lookForSelectedConfig();
    }, [preSelect]);

    const lookForSelectedConfig = () => {
      var defaultValue = null;
      if (configurations != null) {
        configurations.forEach((item) => {
          if (preSelect != null && preSelect !== undefined && item.id === preSelect.id)
            defaultValue = item;
        });
      }
      setSelectedConfig(defaultValue)
    }

  	const getConfigurations = () => {
  		setLoading(true);
  		service.api.configurations.getAll((response) => {
  			if (response.error == null) {
  				var defaultValue = null;
  				response.result.data.forEach((item) => {
  					item.label = item.name + " (#" + item.id +")";
  					if (preSelect != null && preSelect !== undefined && item.id === preSelect.id)
  						defaultValue = item;
  				});
  				setConfigurations(response.result.data);
  				setSelectedConfig(defaultValue)
  			} else {
  				setConfigurations(null);
  			}
  			setLoading(false);
  		})
  	}

	return(
		<Grid container alignItems="center" spacing={2}>
      <Grid item xs={11} style={{maxWidth: 'calc(100% - 120px)'}}>
				<Autocomplete 
					disabled={configurations == null || disabled}
					options={configurations != null ? configurations : []}
					renderInput={(params) => <TextField {...params} label="Formulario" />} 
					value={selectedConfig}
			        onChange={ (event, newValue) => {
			          select(newValue);
			        }}
				/>
			</Grid>
			<Grid item xs={1} style={{maxWidth: '60px', minWidth: '60px'}}>
				{ loading ? 
					(
						<IconButton disabled={true} style={{ color: Constants.COLOR_PRIMARY }}>
           		<CircularProgress color="inherit" size={22}/>
          	</IconButton>
        	) : (
        		<IconButton disabled={disabled} onClick={getConfigurations}>
							<RefreshIcon fontSize="inherit" />
						</IconButton>
        	)
				}
			</Grid>
      <Grid item xs={1} style={{maxWidth: '60px', minWidth: '60px'}}>
          <IconButton disabled={loading || selectedConfig == null} onClick={() => setPreview(true)}>
            <LaunchIcon fontSize="inherit" />
          </IconButton>
      </Grid>

      { preview ? (
         <NewWindow onUnload={() => {setPreview(false)}} >
          <div className={style.box} style={{padding:"14px"}}>
            <ConfigurationPreview configurationId={selectedConfig.id}/>
          </div>
        </NewWindow>) : (null)
      }

		</Grid>
	
	)
}